/**
* Related Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Related Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'related-treatments',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const buttons = $( '.related-treatments__button' ); // Buttons containing progress bars
      const progressBars = $( '.related-treatments__progress-bar' ); // Progress bars inside the buttons
      let currentIndex = 0; // Tracks the currently animating bar
      let timeout; // Holds the timeout for the sequence
      let animationInProgress = false; // Prevents multiple animations

      function resetAllBars() {
        progressBars.stop( true, true ).css( 'width', '0%' ); // Stop all animations and reset widths
      }

      function animateBar( index, click ) {
        if ( animationInProgress ) return; // Prevent overlapping animations

        // Reset all bars
        resetAllBars();
        if ( click ) {
          $( buttons[index] ).click();
        }
        const bar = $( progressBars[index] );
        animationInProgress = true;

        // Animate the current bar
        bar.animate(
            {width: '100%'},
            8000, // Animation duration in milliseconds
            function() {
              animationInProgress = false;

              // Reset the current bar to 0%
              bar.css( 'width', '0%' );

              // Move to the next button
              currentIndex = ( index + 1 ) % progressBars.length; // Loop back to the start
              continueSequence(); // Continue the sequence automatically
            },
        );
      }

      function continueSequence() {
        // Clear any existing timeout to avoid overlap
        clearTimeout( timeout );

        // Start the animation for the current index after a delay
        timeout = setTimeout( () => {
          animateBar( currentIndex, true );
        }, 0 ); // No delay to continue immediately
      }

      function stopSequence() {
        clearTimeout( timeout );
        animationInProgress = false;
      }

      // Handle button clicks
      buttons.on( 'click', function() {
        const clickedIndex = buttons.index( this ); // Get the index of the clicked button

        // Stop the current sequence and reset
        stopSequence();
        resetAllBars();

        // Update the current index and animate from the clicked button
        currentIndex = clickedIndex;
        animateBar( currentIndex, false );
      } );

      // Start the sequence from the first button when the page loads
      animateBar( currentIndex, false );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'related-treatments', COMPONENT );
} )( app );
